export const leftList = [
  {
    label: "概览",
    name: "overview"
  },
  {
    label: "页面访问量",
    name: "pageCount"
  },
  {
    label: "安装下载量",
    name: "userCount"
  },
  {
    label: "官网咨询",
    name: "consultList"
  },
  {
    label: "客户管理",
    name: "customers"
  },
  {
    label: "用户列表",
    name: "registerList"
  }
];

export const routeList = {};

leftList.filter(list => {
  routeList[list.name.toUpperCase()] = `/${list.name}`;
});

export function getLabel(name) {
  return leftList.filter(list => list.name === name)[0].label;
}

export function getName(label) {
  return leftList.filter(list => list.label === label)[0].name;
}



// WEBPACK FOOTER //
// ./src/utils/sideList.js